import { IconName, IconsLibrary } from 'core/constants/IconsLibrary'
import { getIconeInfo } from 'core/utils/service'
import { DEFAULT_APP_ICONE } from 'core/constants/general'

export const IconComponent: React.FC<{
  iconInfo: string | null | undefined
  className?: string
}> = ({ iconInfo, className = 'w-[60px] h-[60px]' }) => {
  const {
    colorIcon,
    colorBackground,
    svg,
  }: { colorIcon: string; colorBackground: string; svg: IconName } =
    getIconeInfo(iconInfo)

  const Icon = IconsLibrary[svg] || IconsLibrary[DEFAULT_APP_ICONE]
  if (!Icon) {
    return null
  }
  return (
    <div
      className={`rounded-full flex items-center justify-center ${className}`}
      style={{ backgroundColor: colorBackground }}
    >
      <Icon style={{ color: colorIcon }} className="h-[60%] w-[60%]" />
    </div>
  )
}
